// @ts-ignore
import requestIdleCallback from 'ric-shim'
import { setActivated } from '../components/TabBar/state'
import { thirdPageName, thirdPagePath } from '../pages/third-page/config';

import type { PluginOptions } from './type';
import { useSettingsStore } from '../stores';

const options: PluginOptions = {
  onVuePluginRegister: async ({ router }) => {
    const settingsStore = useSettingsStore()
    const defaultLayout = router?.getRoutes().filter((item) => item.meta.isLayout)[0].components
    router?.addRoute({
      path: thirdPagePath + '/:subPath(.*)*',
      component: defaultLayout?.default,
      children: [
        {
          name: thirdPageName,
          path: '',
          component: () => import('../pages/third-page/index.vue'),
        },
      ],
    });

    router?.beforeEach((to, from, next) => {
      const { requestIdleCallbackTimeout } = settingsStore.settings.route

      // 激活当前tab，路由放到下个时间循环中执行，避免低CPU机型上的资源竞争
      setActivated(to);
      if (!requestIdleCallbackTimeout || requestIdleCallbackTimeout < 0) {
        next()
        return
      }
      requestIdleCallback(() => {
        if (to.path.startsWith(thirdPagePath) && to.name !== thirdPageName) {
          next({ path: to.path, query: to.query, hash: to.hash })
          return
        }
        next()
      }, { timeout: requestIdleCallbackTimeout });
    })
  },
};

export default options;
